window.TrocarFilialOrcamentoController = ControllerBase.extend({ // FNX-5036
    name: "TrocarFilialOrcamentoController",
    framework: "knockout",
    bindingRegion: "#form-trocarfilial-orcamento-container",

    formConfig: {
        selector: "#form-trocarfilial-orcamento",
        submit: {
            selector: "#trocarFilial-orcamento",
            loadingText: "Aguarde...",
            callback: "trocarFilial",
            type: "model",
            modelType: "js"
        },
        rules: {
            'TrocarFilial_NovaFilial': {
                required: true
            }
        },
        messages: {
            'TrocarFilial_NovaFilial': {
                required: 'Selecione a nova filial para a troca.'
            }
        },

        ignore: []

    },

    events: {
        'click #entrar-trocar-filial-orcamento': 'validarSenhaPermissao',
        'submit #form-senha-trocar-filial-orcamento':  'validarSenhaPermissao'
    },

    antesBinding: function () {
        var self = this;
        // Início - Controle de Exclusividade.
        // 491123 — namespaced (.controleExclusividade): sem namespace, o $(window).unbind("beforeunload")
        // de pesquisarOrcamentoController.excluirControleExclusividade() apaga TODO handler de
        // beforeunload em window, inclusive o de orcamentoController (aviso de orçamento em andamento).
        $(window).on("beforeunload.controleExclusividade", $.proxy(this.confirmExit, this));
        $(window).on("unload.controleExclusividade", $.proxy(this.leavePage, this));
        // Fim - Controle de Exclusividade.

        this.appendToModel({ name: 'Filiais', value: [] });

        this.select2NovaFilial = {
            ajax: {
                url: '/Orcamento/_ObterListaFiliais',
                type: 'get',
                data: function (params) {
                    return {
                        CodigoFilialIgnorar: self.model.CodigoFilialPedido,
                        filialPesquisa: params.term,
                    };
                },
                processResults: function (data) {
                    return {
                        results: $.map(data, function (i) {
                            return { id: i.Codigo, text: i.Descricao };
                        })
                    };
                }
            },
            minimumInputLength: 0
        };
        
    },
    aposBinding: function () {
        
        if (parametroSistema.obter("SOLICITAR_SENHA_TROCA_FILIAL_ORCAMENTO").Valor === "S") {
            $("#trocarFilial_SenhaAutorizarTroca").focus();
        }
        else {
            $("#form-trocarfilial-orcamento-container").show();
        }
        //$("#select2-container--default").attr('min-width', '300px');
        $(".select2-container--default").css('width', 300);


        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });

    },

    // Início - Controle de Exclusividade.
    confirmExit: function () {
        
        global.ajax({
            url: "/Comum/ExcluirControleDeExclusividade",
            type: "post",
            async: false,
            data: {
                actionParameter: this.numeroPedido,
                nomeTabela: "PEDICLICAD"
            }
        });
        return;
    },

    leavePage: function () {
        global.ajax({
            url: "/Comum/ExcluirControleDeExclusividade",
            type: "post",
            async: false,
            data: {
                actionParameter: this.numeroPedido,
                nomeTabela: "PEDICLICAD"
            }
        });
    },
    // Fim - Controle de Exclusividade.

    ajax: function () {
        return {
            url: "/Orcamento/_TrocarFilialOrcamento",
            type: "post",
            data: {
                numeroPedido: this.numeroPedido,
            }
        };
    },

    atacharEventos: function () {
        //$("#breadcrumb-cancelar").unbind();
        //$("#breadcrumb-cancelar").click($.proxy(this.pesquisarAoVoltar, this));
        $("input").on('focus', function () { $(this).select(); });
    },

    pesquisarAoVoltar: function () {
        this.trocarFilialOrcamentoCallback();
    },

    validarSenhaPermissao: function () {
        var self = this;
        var senha = $("#trocarFilial_SenhaAutorizarTroca").val()
        
        global.ajax({
            url: '/Orcamento/ValidarPermissaoSenhaVenda',
            type: 'post',
            data: {
                senha: senha,
                permissao: 'TIPO_LIBERACAO_LIBERA_TROCA_FILIAL_ORCAMENTO',
            },
            error: function () {
                global.unblockUI();
                global.showDefaultErrorMessage();
            },
            success: function (data) {

                if (data && data === true) {
                    $("#trocaFilial-fieldSet-Senha").hide();
                    $("#form-trocarfilial-orcamento-container").show();
                }

                global.unblockUI();
            }
        });

    },

    trocarFilial: function () {
        
        global.blockUI();
        var self = this;
        var numeroPedido = this.model.Numero();
        var codigoNovaFilial = this.model.CodigoNovaFilial();
        var oidFilialPedido = this.model.OidFilialPedido();
        var senhaAutorizacao = $("#trocarFilial_SenhaAutorizarTroca").val()

        global.ajax({
            url: '/Orcamento/TrocarFilial',
            type: 'post',
            data: {
                numeroPedido: numeroPedido,
                codigoNovaFilial: codigoNovaFilial,
                oidFilialPedido: oidFilialPedido,
                senhaAutorizacao: senhaAutorizacao,
            },
            error: function () {
                global.unblockUI();
                global.showDefaultErrorMessage();
            },
            success: function (data) {
                
                if (!data || data === null || data.HasErrors) {
                    global.showErrorMessage("Não foi possível trocar a filial!");
                    global.unblockUI();
                    return false;
                }
                
                global.showSuccessMessage("Troca de Filial concluída com sucesso!");


                $("#breadcrumb-cancelar").click();
                self.trocarFilialOrcamentoCallback();
                global.unblockUI();
                
                return true;
            }
        });
    },
});